import {z} from 'zod'

import {MaterialErrorCodes} from './errorCodes'
import {MixForm} from './types'

export const validateMaterial = (data: Pick<MixForm, 'material'>, ctx: z.RefinementCtx) => {
  // Check if material is selected
  if (data.material === undefined || data.material === null) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['material'],
      message: MaterialErrorCodes.required
    })
    return
  }
}
